import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/css'; // デフォルトのテーマを読み込んでいます（コアスタイルのみ読み込む設定も可能）
import '@splidejs/react-splide/css'; // デフォルトのテーマ

// 画像のインポート
import BottomSlider_01 from "../images/BottomSlider_01.png";
import BottomSlider_02 from "../images/BottomSlider_02.png";
import BottomSlider_03 from "../images/BottomSlider_03.png";
import BottomSlider_04 from "../images/BottomSlider_04.png";
import BottomSlider_05 from "../images/BottomSlider_05.png";
import BottomSlider_06 from "../images/BottomSlider_06.png";

const SliderSlide = () => {
  return (
    <>
      <Splide
        aria-label="トップページスライダ"
        options={{
          type : 'loop', // スライダーのタイプ：「slide」「loop」「fade」から指定
          autoplay: true, // 自動再生を有効
          interval: 3000, // 自動再生の間隔を3秒に設定
          //rewind: false,
          arrows: true,
          autoHeight: true,
          pagination: false,
          pauseOnHover: false,
          speed: 2000,
          perPage: 5,
          perMove: 1,
          breakpoints: {
            1024: {
              perPage: 2,
              fixedWidth: '45%',
            }
          },
        }}
      >
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_01} alt="スライダー1" />
        </SplideSlide>
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_02} alt="スライダー2" />
        </SplideSlide>
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_03} alt="スライダー3" />
        </SplideSlide>
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_04} alt="スライダー4" />
        </SplideSlide>
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_05} alt="スライダー4" />
        </SplideSlide>
        <SplideSlide>
          <img className="slide-img" src={BottomSlider_06} alt="スライダー4" />
        </SplideSlide>
      </Splide>

      {/* 画像の高さを揃えて表示させるために以下スタイルを適用 */}
      <style jsx>{`
        .slide-img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </>
  );
};
export default SliderSlide;